import { useState } from 'react';
import { useAuthActions } from '../state/AuthContext';
import { requestAndRegister } from '../api/pushClient';
import { updateNotificationPrefs } from '../api/authClient';
import '../styles/auth.css';
import '../styles/notifications.css';

// Soft pre-prompt shown once after a user's universe is first built. Saying
// "Enable" triggers the real iOS permission dialog; either choice marks the
// account as prompted so we never nag again.
function NotificationOptInModal({ onClose }) {
  const { setNotificationPrompted } = useAuthActions();
  const [busy, setBusy] = useState(false);

  const dismiss = (markPrompted = true) => {
    if (markPrompted) setNotificationPrompted();
    onClose();
  };

  const handleEnable = async () => {
    setBusy(true);
    try {
      const status = await requestAndRegister();
      if (status === 'granted') {
        await updateNotificationPrefs('recommendation', true, 'weekly').catch(() => {});
      }
    } finally {
      dismiss(true);
    }
  };

  return (
    <div className="auth-modal-overlay" onClick={() => dismiss(true)}>
      <div
        className="auth-modal notif-optin-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="auth-modal-close" onClick={() => dismiss(true)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="notif-optin-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
        </div>

        <h2 className="auth-modal-title">Your universe is alive</h2>
        <p className="notif-optin-copy">
          Want a weekly pick from your universe? We'll surface a new artist worth
          exploring and tell you who in your orbit they're connected to.
        </p>

        <div className="notif-optin-actions">
          <button className="notif-optin-primary" onClick={handleEnable} disabled={busy}>
            {busy ? 'Enabling…' : 'Enable weekly recommendations'}
          </button>
          <button className="notif-optin-secondary" onClick={() => dismiss(true)} disabled={busy}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotificationOptInModal;
